import { Component, OnInit } from '@angular/core';
import { HeaderService } from '../../services/header/header.service';

@Component({
  selector: 'tcat-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  isShowingHeader$ = this.headerService.shouldShowHeader();
  
  constructor(private headerService: HeaderService) { }

  ngOnInit(): void {
  }

}
